import React from 'react'
import { ReactComponent as CloseSvg } from '../../../assets/svg/close.svg'
import { CloseBtnProps } from './interfaces'
import SFXS from '../../../assets/audios/audios'

export default function CloseBtn({ handleAbove, audio }: CloseBtnProps) {
  const { goBackSFX } = SFXS
  goBackSFX.volume = audio.volume
  return (
    <CloseSvg
      onClick={() => {
        audio.sound && goBackSFX.play()
        handleAbove(false)
      }}
      data-testid='closeBtn'
    />
  )
}
